import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authContext.jsx';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  return children;
}
